<div class="banner-container"
     (touchstart)="onTouchStart($event)"
     (touchend)="onTouchEnd($event)">
  <div class="carousel-track" 
       [style.transform]="'translateX(' + (-currentIndex * 100) + '%)'"
       [style.transition]="isTransitioning ? 'transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)' : 'none'">
    <div class="carousel-slide" *ngFor="let banner of extendedBanners; let i = index">
      <div class="slide-wrapper">
        <div class="banner-card" 
             [style.background]="banner.color"
             (click)="checkAndOpenBanner(banner)">
          <div class="glass-effect"></div>
          <div class="banner-content">
            <div class="text-section">
              <h3>{{ banner.title }}</h3>
              <p>{{ banner.text }}</p>
            </div>
            <div class="icone-section">
              <i [class]="banner.icon"></i>
            </div>
          </div>
          <!-- Decorative elements -->
          <div class="circle-1"></div>
          <div class="circle-2"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Identificadores (Dots) -->
  <div class="carousel-indicators" *ngIf="banners.length > 1">
    <span *ngFor="let banner of banners; let i = index" 
          [class.active]="i === activeDotIndex"
          (click)="goToSlide(i)"></span>
  </div>

  <!-- Modal Expanded View -->
  <div class="modal-backdrop" *ngIf="selectedBanner" (click)="closeModal()">
    <div class="modal-content" 
         [style.background]="selectedBanner.color"
         (click)="$event.stopPropagation()">
      
      <button class="modal-close-btn" (click)="closeModal()">
        <i class="fa-solid fa-times"></i>
      </button>

      <div class="modal-body">
        <div class="modal-icon-wrapper">
          <i [class]="selectedBanner.icon"></i>
        </div>
        
        <h2 class="modal-title">{{ selectedBanner.title }}</h2>
        <p class="modal-text">{{ selectedBanner.text }}</p>
      </div>

      <!-- Decorative circles for consistency -->
      <div class="circle-1" style="opacity: 0.3;"></div>
      <div class="circle-2" style="opacity: 0.3;"></div>
    </div>
  </div>
</div>
